import { useQuery } from "@tanstack/react-query";
import { PaymentService } from "../services/paymentService";

const usePaymentMethods = () => {
 return useQuery({
    queryKey: ["paymentMethods"],
    queryFn: () => PaymentService.getPaymentMethods(),
  });
};

export default usePaymentMethods;